import React, { useMemo } from 'react';
import { formatReminderLabel, groupTemplatesByType } from './templateTypeGroups';

function TemplateTypeList({ templates, selectedId, onSelect, isSaving, itemIcon = 'bi-file-earmark-text' }) {
    const groupedTemplates = useMemo(() => groupTemplatesByType(templates), [templates]);

    return (
        <div className="templates-type-groups">
            {groupedTemplates.map((group) => (
                <section key={group.id} className="templates-type-group">
                    <div className="templates-type-group__header">
                        <span className="templates-type-group__heading">
                            <i className={`bi ${group.icon}`}></i>
                            {group.label}
                        </span>
                        <span className="templates-type-group__count">{group.templates.length}</span>
                    </div>

                    <div className="clinic-settings-record-list templates-list">
                        {group.templates.map((template) => (
                            <button
                                key={template.id}
                                type="button"
                                className={`clinic-settings-record-item templates-list-item ${
                                    selectedId === template.id ? 'is-active' : ''
                                }`}
                                onClick={() => onSelect(template.id)}
                                disabled={isSaving}
                            >
                                <span className="clinic-settings-record-item__avatar">
                                    <i className={`bi ${itemIcon}`}></i>
                                </span>
                                <div className="clinic-settings-record-item__main">
                                    <h6 className="clinic-settings-record-item__title mb-0">
                                        {formatReminderLabel(template.reminderName)}
                                    </h6>
                                </div>
                                <div className="clinic-settings-record-item__actions">
                                    <span
                                        className={`clinic-settings-status-pill ${
                                            template.status ? 'is-open' : 'is-closed'
                                        }`}
                                    >
                                        {template.status ? 'Active' : 'Inactive'}
                                    </span>
                                </div>
                            </button>
                        ))}
                    </div>
                </section>
            ))}
        </div>
    );
}

export default TemplateTypeList;
